import styled from "styled-components";
const Title = styled.div`
  font-size: 40px;
  text-transform: lowercase;
  line-height: 40px;
  font-weight: 800;
  width: max-content;

  @media (max-width: 1599px) {
    font-size: 25px;
    line-height: normal;
  }
  @media (max-width: 991px) {
    font-size: 20px;
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
  }
  @media (max-width: 575px) {
    font-size: 20px;
    width: 100%;
    text-align: center;
    margin-bottom: 15px;
  }
`;
export default Title;
